import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { AntaiFluxDto } from 'lib_api/lib/api/gen';

import { useApi } from '../ApiStoreContext';
import { useHandleBackErrors } from '../utils/handleBackErrors';

export function useFetchFluxAntai(id: string): UseQueryResult<AntaiFluxDto> {
  const { AdminFonctionnelControllerApi } = useApi();
  const behaviourOnError = useHandleBackErrors();

  function fetchFlux(): Promise<AntaiFluxDto> {
    return AdminFonctionnelControllerApi.searchSpecificFluxUsingGET(id).catch(
      (error: Response) => {
        behaviourOnError(error);
        return Promise.reject(error);
      },
    );
  }

  return useQuery({
    queryKey: ['flux', id],
    queryFn: fetchFlux,
    enabled: !!id,
  });
}
